import { Box, Heading } from '@zillow/constellation-10';

import { wizardFormSectionContainerStyles, wizardHeadingStyles } from '../../../../styles/wizard';

import RoommateCountFormField from '../../../PostingPath/RoommateCountFormField';
import PageWizard from '../../../Wizard/PageWizard';

import type { WizardBodyTemplateProps } from '../../../WizardStepController';

const RoomHowManyRoommates = ({
  onGoToNextStep,
  onGoToPrevStep,
  onExitWizard,
  wizardTitle,
  progressStepper,
  totalSteps,
  currentStepIndex,
  ...rest
}: WizardBodyTemplateProps) => (
  <PageWizard
    {...rest}
    title=""
    wizardTitle={wizardTitle}
    progressStepper={progressStepper}
    totalSteps={totalSteps}
    currentStepIndex={currentStepIndex}
    onNextClick={onGoToNextStep || undefined}
    onBackClick={onGoToPrevStep || undefined}
    onExitTriggered={onExitWizard}
  >
    <Box className={wizardFormSectionContainerStyles()}>
      <Heading level={2} textStyle="heading-sm" css={wizardHeadingStyles}>
        How many roommates will the renter have?
      </Heading>

      <RoommateCountFormField />
    </Box>
  </PageWizard>
);

export default RoomHowManyRoommates;
